const initialStateFilters = {
  ciclo: {id: 1, name: 'Janeiro'},
  compararCiclos: {id: 'ativar', name: 'Ativar'},
  dataInicial: '',
  dataFinal: ''
}

const initialState = {
  projetos: [],
  projeto: {},
  cliente: {},
  grafico: [],
  graficoLoad: false,
  filtersProvisorio: initialStateFilters,
  totalAvaliacao: 0,
  tooltipAtual: [],
  tooltipAnterior: [],
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case 'LIST_PROJETOS':
      return { ...state, projetos: payload}
    case 'INFO_PROJETO':
      return { ...state, projeto: payload}
    case 'INFO_CLIENTE':
      return { ...state, cliente: payload}
    case 'INFO_FILTERS_NPSCLIENTE':
      return { ...state, filtersProvisorio: payload}
    case 'CHANGE_FILTERS_NPSCLIENTE':
      return { ...state, filtersProvisorio: {...state.filtersProvisorio, [payload.name]: payload.value}}
    case 'CLEAN_FILTERS_NPSCLIENTE':
      return { ...state, filtersProvisorio: initialStateFilters}
    case 'LOAD_GRAFICO_NPSCLIENTE':
      return { ...state, graficoLoad: payload}
    case 'INFO_GRAFICO_NPSCLIENTE':
      return { ...state, grafico: payload}
    case 'INFO_GRAFICO_NPSCLIENTE_TOTAL_AVALIACAO':
      return { ...state, totalAvaliacao: payload}
    case 'INFO_TOOLTIP_ATUAL':
      return { ...state, tooltipAtual: payload}
    case 'INFO_TOOLTIP_ANTERIOR':
      return { ...state, tooltipAnterior: payload}
  
    default:
      return state
  }
}